// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--3p3Iz","item":"_6c97079b1b--item--1W2T0","title":"_6c97079b1b--title--35CS6"};